
export default {
    components: {},
    props: {
        visible: {
            type: Boolean,
            default: false
        },
        tips: {
            type: String,
            default: ''
        },
        title: {
            type: String,
            default: ''
        },
        clickMaskClose: {
            type: Boolean,
            default: true
        },
        showMask: {
            type: Boolean,
            default: true
        },
        position: {
            type: String,
            default: 'center'
        },
        width: {
            type: String,
            default: '330px'
        }
    },
    data () {
        return {
            originalParent: null,
            parentEl: '.conversation + .chat'
        }
    },
    computed: {
        fadeName () {
            if (this.position === 'right') {
                return 'fade-right'
            }
            return 'fade'
        }
    },
    watch: {
        visible (newVal) {
            if (newVal) {
                this.moveToPortal()
            }
            // 移除时不在这里调用 moveBack，而是在过渡动画完成后调用
        }
    },
    mounted () {
        if (this.visible) {
            this.moveToPortal()
        }
    },
    beforeDestroy () {
        this.moveBack()
    },
    methods: {
        moveToPortal () {
            this.$nextTick(() => {
                const parentDom = document.querySelector(this.parentEl)
                const popup = this.$refs.popup

                if (parentDom && popup) {
                    // 记录原始父元素
                    this.originalParent = popup.parentNode
                    // 移动到指定容器中
                    parentDom.appendChild(popup)
                }
            })
        },
        moveBack () {
            const popup = this.$refs.popup
            if (popup && this.originalParent) {
                // 移回原位置
                this.originalParent.appendChild(popup)
            }
        },
        close () {
            this.$emit('close')
            this.$emit('update:visible', false)
        },
        handleOverlayClick () {
            if (this.clickMaskClose) {
                this.close()
            }
        }
    }
}
